export default __webpack_public_path__ + "static/media/gallery-wip-greeblies_11.a7ce153f.jpg";